import { Flex } from '@sqs/rosetta-primitives';
import React from 'react';

interface UserImageProps {
  readonly name: string;
  readonly imageUrl?: string;
}

export const UserImage = ({ name, imageUrl }: UserImageProps) => {
  const firstLetter = name ? name[0] : '?';

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt={name}
        style={{
          width: '70px',
          height: '70px',
          borderRadius: '50%',
          objectFit: 'cover',
        }}
      />
    );
  }
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      style={{
        fontSize: '32px',
        backgroundColor: '#23B2C6',
        color: '#fff',
        width: '70px',
        height: '70px',
        borderRadius: '50%',
      }}
      aria-label={name}
      role="img"
    >
      {firstLetter}
    </Flex>
  );
};
